export enum SystemTypes {
    NONE = 0,
    SAP = 1,
    ORACLE = 2,
    PARTNER = 3,
    JDE = 4,
    SALESFORCE = 5,
    GENERIC = 6
}

type SystemTypesKey = keyof typeof SystemTypes;

export const AllSystemTypes: SystemTypes[] = Object.keys(SystemTypes).map((key: string) => SystemTypes[key as SystemTypesKey]);

export enum SapSystemSubTypes {
    NONE = 0,
    ECC = 1,
    SFIN = 2,
    SCM = 3
}

export const SystemTypeConstants = {
    SAP: SystemTypes[SystemTypes.SAP],
    ORACLE: SystemTypes[SystemTypes.ORACLE],
    PARTNER: SystemTypes[SystemTypes.PARTNER],
    JDE: SystemTypes[SystemTypes.JDE],
    SALESFORCE: SystemTypes[SystemTypes.SALESFORCE],
    GENERIC: SystemTypes[SystemTypes.GENERIC]
};
